<template>
  <project-manager-layout @scrolled-to-bottom="handleScrolledToBottom">
    <template #default>
      <a-row justify="space-between">
        <a-col>
          <main-title>Мои проекты</main-title>
        </a-col>
        <a-col>
          <c-button-primary :loading="isLoading" @click="handleStart">
            Добавить проект
          </c-button-primary>
        </a-col>
      </a-row>
      <horizontal-filter>
        <template #default>
          <filter-item path="/leader/requests" text="Новые запросы" />
          <filter-item hash="#inwork" text="В работе" />
          <filter-item hash="#archive" text="Архив" />
        </template>
        <template #right>
          <label class="panel__total-items"> Всего: {{ totalItems }} </label>
          <switch-cards-table-view
            :type-view="typeView"
            @update:type-view="handleUpdateTypeView"
          />
        </template>
      </horizontal-filter>
      <projects-filter
        :status-list="statusList"
        @update-filter="updateFilter"
      />
      <infinite-grid-layout
        :get-items="api.project.projectStats"
        :url-params="urlParams"
        :scroll-bottom="scrollBottom"
        :one-column="typeView === 'table'"
        entity="projects"
        @update-total-count="handleUpdateTotalCount"
      >
        <template #table-header v-if="typeView === 'table'">
          <project-table-header />
        </template>
        <template #table-item="slotProps">
          <template v-if="typeView === 'table'">
            <router-link :to="getLink(slotProps.item)">
              <project-table-item :project="slotProps.item" />
            </router-link>
          </template>
          <template v-else>
            <router-link :to="getLink(slotProps.item)">
              <project-card :project="slotProps.item" />
            </router-link>
          </template>
        </template>
      </infinite-grid-layout>
    </template>
  </project-manager-layout>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import CButtonPrimary from '@/components/UI/CButtonPrimary';
  import ProjectsFilter from '@/components/projects/components/ProjectsFilter.vue';
  import ProjectCard from '@/components/projects/components/ProjectCard.vue';
  import { PROJECT_TAB_IN_WORK } from '@/constants/project-tab';
  import {
    PROJECT_STATUS_NAME_ACCEPTANCE,
    PROJECT_STATUS_NAME_AGREEMENT,
    PROJECT_STATUS_NAME_DRAFT,
    PROJECT_STATUS_NAME_IN_WORK,
  } from '@/constants/project-status';
  import SwitchCardsTableView from '@/components/switch-view/SwitchCardsTableView.vue';
  import ProjectTableItem from '@/components/projects/components/ProjectTableItem.vue';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';
  import ProjectTableHeader from '@/components/projects/components/ProjectTableHeader.vue';

  const api = useApi();
  const router = useRouter();
  const route = useRoute();
  const totalItems = ref(0);
  const scrollBottom = ref(0);
  const isLoading = ref(false);
  const urlParams = ref(null);
  const typeView = ref('table');

  const statusList = computed(() => {
    const tab = route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK;
    switch (tab) {
      case PROJECT_TAB_IN_WORK:
        return [
          PROJECT_STATUS_NAME_DRAFT,
          PROJECT_STATUS_NAME_IN_WORK,
          PROJECT_STATUS_NAME_AGREEMENT,
          PROJECT_STATUS_NAME_ACCEPTANCE,
        ];
      // case PROJECT_TAB_ARCHIVE:
      //   return [PROJECT_STATUS_NAME_CLOSED, PROJECT_STATUS_NAME_REJECTED];
      default:
        return [];
    }
  });

  onMounted(() => {
    urlParams.value = new URLSearchParams({
      tab: route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK,
      role: route.meta.role,
    });
    if (route.query.textSearch) {
      urlParams.value.set('textSearch', route.query.textSearch);
    }
  });

  watch(
    () => route.hash,
    async () => {
      updateFilter(new URLSearchParams([...urlParams.value]));
    }
  );

  const updateFilter = (filterParams) => {
    filterParams.set(
      'tab',
      route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK
    );
    urlParams.value = filterParams;
  };

  const handleUpdateTypeView = (value) => {
    typeView.value = value;
  };

  const handleScrolledToBottom = (value) => {
    scrollBottom.value = value;
  };

  const handleUpdateTotalCount = (value) => {
    totalItems.value = value;
  };

  const handleStart = async () => {
    try {
      isLoading.value = true;
      // создаем новый проект, если в createProject() не передаем аргументы, то присваиваем следующий по очереди projectId
      const response = await api.leaderPage.createInternalProject({
        parentId: null,
      });

      await router.replace({
        path: `/leader/project/${response.projectId}/form`,
      });
    } catch (error) {
      console.error('error', error);
    } finally {
      isLoading.value = false;
    }
  };

  const getLink = (project) => {
    if (route.hash === '') {
      return `/leader/project/${project.id}/form`;
    } else if (route.hash === '#inwork') {
      return `/leader/project/${project.id}/form#1`;
    } else if (route.hash === '#archive') {
      return `/leader/project/${project.id}/report`;
    }
  };
</script>

<style lang="scss" scoped>
  .panel__total-items {
    align-self: center;
  }
</style>
